import api from '../..'
import { IFolderModel } from 'models/folder.model'

const editFolder = (data: IFolderModel, id: number) => {
  const folder = { folder: data }
  return api.patch(`/administration/folders/${id}'`, folder)
}

export default editFolder
